/**
 * @flow
 * @relayHash d925cec4b3534f4c76a3f4b6063eae96
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type draftArgumentsInputType = {|
  game_id: string,
  quarter_id: string,
  group_id?: ?string,
|};
export type RosterQueryVariables = {|
  draftArguments?: ?draftArgumentsInputType
|};
export type RosterQueryResponse = {|
  +getDraftingOptions: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?$ReadOnlyArray<?{|
      +_id: ?string,
      +game_id: ?string,
      +quarter_id: ?string,
      +group_id: ?string,
      +external_player_id: ?string,
      +option: ?{|
        +_id: ?string,
        +option: ?string,
        +option_type_id: ?string,
      |},
    |}>,
  |}
|};
export type RosterQuery = {|
  variables: RosterQueryVariables,
  response: RosterQueryResponse,
|};
*/


/*
query RosterQuery(
  $draftArguments: draftArgumentsInputType
) {
  getDraftingOptions(draftArguments: $draftArguments) {
    code
    message
    data {
      _id
      game_id
      quarter_id
      group_id
      external_player_id
      option {
        _id
        option
        option_type_id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "draftArguments",
    "type": "draftArgumentsInputType",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "_id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "getDraftingOptions",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "draftArguments",
        "variableName": "draftArguments"
      }
    ],
    "concreteType": "draftOptionsType",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "draftOptionDataType",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "game_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "quarter_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "group_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "external_player_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "option",
            "storageKey": null,
            "args": null,
            "concreteType": "gameDataOptionsType",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "option",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "option_type_id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RosterQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "RosterQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "RosterQuery",
    "id": null,
    "text": "query RosterQuery(\n  $draftArguments: draftArgumentsInputType\n) {\n  getDraftingOptions(draftArguments: $draftArguments) {\n    code\n    message\n    data {\n      _id\n      game_id\n      quarter_id\n      group_id\n      external_player_id\n      option {\n        _id\n        option\n        option_type_id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f8888a679c4b2c81c648e50da85e5b8d';
module.exports = node;
